import React, { ReactNode } from "react";
import cn from "classnames";
import { useSharedTranslations } from "../../lib";
import styles from "./component-radiogroup.module.scss";

export interface IComponentRadioGroupOption {
    value: string;
    text: string;
    icon: ReactNode;
}

interface IComponentRadioGroupProps {
    className?: string;
    value?: string;
    options: IComponentRadioGroupOption[];
    onChange: (value: any) => void;
}

export const ComponentRadioGroup: React.FC<IComponentRadioGroupProps> = React.memo(({
                                                                                        className,
                                                                                        value,
                                                                                        options,
                                                                                        onChange,
                                                                                    }) => {
    return <div className={cn(className, styles.container)}>
        {options.map(option => (
            <div key={option.value} className={cn(styles.option, value === option.value ? styles.optionSelected : "")}
                 onClick={() => onChange(option.value)}>
                {option.icon}
                <div className={styles.textContainer}>{option.text}</div>
            </div>
        ))}
    </div>;
});
